<template>
  <div class="report">
    <div class="total-tiket">
      <div class="left">
        <h4>Jumlah Tiket Dibuat</h4>
        <div class="wrap-h1">
          <h1>{{ datadashboard.jumlahtiket }}</h1>
        </div>
      </div>

      <div class="right">
        <h4>Jumlah Tiket Closed</h4>
        <div class="wrap-h1">
          <h1>{{ datadashboard.jumlahtiketclosed }}</h1>
        </div>
      </div>
    </div>
    <div class="total-perusahaan">
      <div class="left">
        <h4>Jumlah Perusahaan</h4>
        <div class="wrap-h1">
          <h1>{{ datadashboard.jumlahperusahaan }}</h1>
        </div>
      </div>

      <div class="right">
        <h4>Jumlah Petugas</h4>
        <div class="wrap-h1">
          <h1>{{ datadashboard.jumlahpetugas }}</h1>
        </div>
      </div>
    </div>
    <div class="chart-tiket">
      <h4>Perusahaan Paling Banyak Keluhan</h4>

      <div class="listperusahaan">
        <div class="list" v-for="n in listhistory" :key="n">
          <img class="img-p" :src="n.image" />

          <p>{{ n.nama_perusahaan }}</p>
          <p>{{ n.total_pengaduan }} Tiket Keluhan</p>
        </div>
      </div>
    </div>
    <div class="chart-total">
      <h4>5 Top Kategori Perihal</h4>
      <ChartRadComp v-if="show" :parseData="topkategori" />
    </div>
    <div class="daftar-perusahaan">
      <ChartComp v-if="show" :parseData="historytiket" />
    </div>
    <div class="daftar-kategori">
      <h4>Ubah Tanggal</h4>
      <div class="main-date">
        <div class="tgl">
          <label for="">Dari</label>
          <input type="date" name="" id="" v-model="currentFirst" />
        </div>

        <div class="tgl">
          <label for="">Sampai</label>
          <input type="date" name="" id="" v-model="currentLast" />
        </div>

        <div class="tgl">
          <div style="color: transparent">&</div>
          <button @click="getAllData(true)">ubah</button>
        </div>
      </div>
    </div>
  </div>
</template>
<style scoped>
h1,
h2,
h3,
h4,
h5 {
  font-family: poppins-semi;
}

h4 {
  font-family: poppins-reg;
}

.report {
  background-color: transparent;
  height: 100%;
  width: 100%;
  display: grid;
  grid-template-areas:
    "totalTiket totalPerusahaan chartTiket"
    "chartTotal chartTotal chartTiket"
    "daftarPerusahaan daftarPerusahaan kategori";
  grid-template-columns: 1fr 1fr 1fr;
  grid-template-rows: repeat(3, 1fr);
  /* atur lebar kolom */
  gap: 10px;
  padding: 20px;
  box-sizing: border-box;
  overflow: hidden;
  /* jarak antar elemen */

  .total-tiket {
    grid-area: totalTiket;
    background-color: #f5f8ffa4;
    padding: 10px 20px;
    box-sizing: border-box;
    border-radius: 20px;
  }

  .total-perusahaan {
    grid-area: totalPerusahaan;
    background-color: #f5f8ffa4;
    padding: 10px 20px;
    box-sizing: border-box;
    border-radius: 20px;
  }

  .total-tiket,
  .total-perusahaan {
    display: grid;
    grid-template-columns: repeat(2, 50%);

    .left,
    .right {
      height: 100%;
      display: grid;
      text-align: center;
      grid-template-rows: max-content auto;
    }

    .wrap-h1 {
      height: 100%;
      display: flex;
      align-items: center;
      justify-content: center;
    }

    h1 {
      height: max-content;
      text-align: center;
      font-size: 30pt;
    }
  }

  .chart-tiket {
    grid-area: chartTiket;
    background-color: #f5f8ffa4;
    padding: 10px 20px;
    padding-bottom: 0 !important;
    box-sizing: border-box;
    border-radius: 20px;

    .listperusahaan {
      width: 100%;
      height: auto;
      background-color: transparent;
      margin-top: 20px;

      .list {
        margin-bottom: 20px;
        display: grid;
        grid-template-columns: max-content auto max-content;
        object-position: center;
        align-items: center;

        .img-p {
          margin-right: 20px;
          height: 50px;
          width: 50px;
          border-radius: 10px;
          object-fit: cover;
          background-color: #dbdbdb;
        }

        p {
          font-size: 10pt;
        }

        p:last-child {
          background-color: #00e396;
          padding: 5px 10px;
          border-radius: 20px;
          color: black;
          font-family: poppins-semi;
        }
      }
    }
  }

  .chart-total {
    grid-area: chartTotal;
    background-color: #f5f8ffa4;
    padding: 10px 20px;
    padding-bottom: 0 !important;
    box-sizing: border-box;
    border-radius: 20px;

    .bawah {
      display: grid;
      grid-template-columns: max-content auto;

      .listPerihal {
        background-color: transparent;
        height: max-content;
        margin-top: auto;
        margin-bottom: auto;

        .list {
          display: grid;
          padding: 5px 0;
          grid-template-columns: max-content auto;
          font-size: 10pt;
        }

        .color {
          height: 15px;
          width: 15px;
          margin-top: auto;
          margin-bottom: auto;
          border-radius: 15px;
          margin-right: 15px;
        }

        .list:nth-child(1) .color {
          background-color: #ff4560;
        }

        .list:nth-child(2) .color {
          background-color: #008ffb;
        }

        .list:nth-child(3) .color {
          background-color: #00e396;
        }

        .list:nth-child(4) .color {
          background-color: #feb019;
        }

        .list:nth-child(5) .color {
          background-color: #775dd0;
        }
      }
    }
  }

  .daftar-perusahaan {
    grid-area: daftarPerusahaan;
    background-color: #f5f8ffa4;
    padding: 10px 20px;
    padding-bottom: 0 !important;
    box-sizing: border-box;
    border-radius: 20px;
  }

  .daftar-kategori {
    grid-area: kategori;
    background-color: #f5f8ffa4;
    padding: 10px 20px;
    padding-bottom: 0 !important;
    box-sizing: border-box;
    border-radius: 20px;

    .main-date {
      display: grid;
      gap: 10px;
      grid-template-columns: repeat(3, auto);

      input {
        display: block;
        padding: 5px 10px;
        border-radius: 5px;
        border: 1px solid black;
        background-color: #f2f2f2;
        font-family: poppins-reg;
        font-size: 9pt;
      }

      .tgl {
        background-color: transparent;
        display: grid;
        align-items: center;

        label {
          font-size: 10pt;
        }

        button {
          padding: 6px 10px;
          font-family: poppins-reg;
          border-radius: 5px;
          border: none;
          background-color: #008ffb;
          color: white;
          font-size: 10pt;
          height: 100%;
        }
      }
    }
  }
}
</style>

<script>
import axios from "axios";
import ChartComp from "./comp/ChartBarComp.vue";
import ChartRadComp from "./comp/ChartRadComp.vue";
import { backend as be } from "@/assets/config/server";
import { getCookie } from "@/assets/config/cookie";
import { cancelAllRequest } from "@/store/request";

// if (window.chatController) {
//     window.chatController.abort();
// }

const getjumlah = (data) => {
  let jum = 0;
  let list_nama = [];
  let list_jum = [];
  data = Array.from(data.slice(0, 15));
  for (const el of data) {
    jum += el.total_kemunculan;
    list_nama.push(el.nama_kategori);
    list_jum.push(el.total_kemunculan);
  }

  return { list_nama: list_nama, list_jum: list_jum, total: jum };
};

export default {
  name: "DashboardReport",
  components: {
    ChartComp,
    ChartRadComp,
  },
  data() {
    return {
      be,
      show: true,
      listPerusahaan: [
        "PT Cahaya Indo Pratama",
        "CV Mitra Sentosa Abadi",
        "Yayasan Bumi Harapan Utama",
        "PT Nusantara Logistik Mandiri",
        "CV Karya Mulia Sejati",
        "PT Teknologi Global Persada",
        "Yayasan Cendekia Inspirasi Bangsa Unggul Tani Maju Jaya",
      ],
      currentFirst: "2025-01-01",
      currentLast: "2025-01-30",
      info: null,
      sessionToken: null,
      topkategori: {
        list_nama: [],
        list_jum: [],
        total: 0,
      },
      datadashboard: {
        jumlahtiket: 0,
        jumlahtiketclosed: 0,
        jumlahperusahaan: 0,
        jumlahpetugas: 0,
      },
      listhistory: [],
      historytiket: {
        dibuat: [],
        closed: [],
      },
      sudahAmbil: false,
      loginInfo : null,
    };
  },
  updated() {},
  mounted() {
    const currentdate = new Date();

    const year = currentdate.getFullYear();
    const month = this.pad2(currentdate.getMonth() + 1);
    const day = this.pad2(currentdate.getDate());

    this.currentFirst = `${year}-${month}-01`;
    this.currentLast = `${year}-${month}-${day}`;

    this.loginInfo = JSON.parse(getCookie("loginInfo"))
    this.sessionToken = this.loginInfo.token;
    this.getAllData(true);
    //console.log(this.sessionToken)
  },

  methods: {
    toDDMMYYYY(dateStr) {
      if (!dateStr) return "";
      if (!dateStr.includes("-")) return dateStr;

      const [y, m, d] = dateStr.split("-");
      return `${d}/${m}/${y}`;
    },
    cekTgl(tgl) {
      tgl = String(tgl);
      if (tgl.length == 1) {
        return `0${tgl}`;
      }

      return tgl;
    },
    pad2(val) {
      return String(val).padStart(2, "0");
    },

    async getApi(api, parameter = {}) {
      try {
        const res = await axios.get(`${be}/${api}`, {
          params: parameter,
          headers: {
            Accept: "application/json",
            Authorization: `Bearer ${this.sessionToken}`,
          },
        });

        return res.data;
      } catch (err) {
        console.error("ERROR API:", api);
        console.error(err);
        return null;
      }
    },

    getAllData(params = null) {
      //console.log(this.currentFirstFormatted, this.currentLastFormatted)
      var links = {
        total_kemunculan: "api/total-kategori-pengaduan",
        total_data: "api/dashboard-data",
        total_history: "api/history-pengaduan",
      };

      if (params === null || params === undefined) {
        links = {
          total_kemunculan: "api/total-kategori-pengaduan",
          total_data: "api/dashboard-data",
          total_history: "api/history-pengaduan",
        };
      } else {
        links.total_kemunculan = `${links.total_kemunculan}?tanggal_awal=${this.currentFirstFormatted}&tanggal_akhir=${this.currentLastFormatted}`;
        links.total_data = `${links.total_data}?tanggal_awal=${this.currentFirstFormatted}&tanggal_akhir=${this.currentLastFormatted}`;
        links.total_history = `${links.total_history}?tanggal_awal=${this.currentFirstFormatted}&tanggal_akhir=${this.currentLastFormatted}`;
      }

      if (!this.sudahAmbil) {
        this.getApi("api/grafik-tiket")
          .then((res) => {
            if (res) {
              this.historytiket.dibuat = res.tiket_masuk;
              this.historytiket.closed = res.tiket_closed;
              this.sudahAmbil = true;
              //console.log(res)
            } else {
              console.log("Gagal memuat total kategori");
            }
          })
          .catch((err) => {
            console.error("Error kategori:", err);
          });
      }

      this.getApi(links.total_kemunculan)
        .then((res) => {
          if (res) {
            this.topkategori = getjumlah(res.data);
          } else {
            console.log("Gagal memuat total kategori");
          }

          //console.log('total kemunuclan',res)
        })
        .catch((err) => {
          console.error("Error kategori:", err);
        });

      // --- Request kedua: dashboard data ---
      this.getApi(links.total_data)
        .then((res) => {
          if (res) {
            this.datadashboard.jumlahperusahaan = res.total_perusahaan;
            this.datadashboard.jumlahpetugas = res.total_petugas;
            this.datadashboard.jumlahtiket = res.total_tiket;
            this.datadashboard.jumlahtiketclosed = res.total_tiket_ditutup;
          } else {
            console.log("Gagal memuat dashboard dat");
          }
          //console.log('total data',res)
        })
        .catch((err) => {
          console.error("Error dashboard:", err);
        });

      this.getApi(links.total_history)
        .then((res) => {
          if (res) {
            this.listhistory = res.data;
          } else {
            console.log("Gagal memuat total kategori");
          }

          //console.log('total history',res)
        })
        .catch((err) => {
          console.error("Error kategori:", err);
        });
    },
  },
  beforeMount() {
    cancelAllRequest();
  },
  computed: {
    currentFirstFormatted() {
      return this.toDDMMYYYY(this.currentFirst);
    },
    currentLastFormatted() {
      return this.toDDMMYYYY(this.currentLast);
    },
  },
};
</script>
